import { generateTestId } from "@client-shared";

export const setDashboardStatsTestId = (identifier: string): string => generateTestId("DashboardStats", identifier);

// Specific testId setters for tests
export const setDashboardStatsContainerTestId = (): string => setDashboardStatsTestId("container");
export const setDashboardStatsCardTestId = (stat: string): string => setDashboardStatsTestId(`card-${stat}`);
